import PropTypes from 'prop-types';

const NewsCard = ({ title, previewImage, url, previewText, postDate }) => (
  <a className="mb-4 text-reset text-decoration-none" href={url}>
    <img
      className="rounded"
      src={previewImage.url}
      alt={previewImage.alt}
      width={previewImage.width}
      height={previewImage.height}
    />

    <div className="mt-5">
      <time className="mt-2">{postDate}</time>
      <h2 className="mt-1 mb-3 h3">{title}</h2>
      {previewText}
    </div>
  </a>
);

export default NewsCard;

NewsCard.propTypes = {
  title: PropTypes.string.isRequired,
  previewImage: PropTypes.shape({
    url: PropTypes.string.isRequired,
    alt: PropTypes.string,
    height: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired,
  }),
  url: PropTypes.string.isRequired,
  previewText: PropTypes.string.isRequired,
  postDate: PropTypes.string.isRequired,
};
